import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import PropTypes from 'prop-types'
import MainLayout from 'components/MainLayout'
import { Container } from 'components/layout/Grid/'
import BackToAdminCentre from 'components/BackToAdminCentre'
import RouteWithSubRoutes from 'components/RouteWithSubRoutes'
import { resetErrorMessage, setErrorMessage } from 'actions/app'
import { hasAccess } from 'utils/hasAccess'
import { getPartnerplanReminderEmailToBeSent, sendPartnerplanReminderEmail } from 'actions/partnerPlanReminderNotification'

class partnerPlanReminderNotification extends Component {
  static propTypes = {
    currentUser: PropTypes.object,
    routes: PropTypes.instanceOf(Array),
    setErrorMessage: PropTypes.func.isRequired,
  }
  static defaultProps = {
    routes: {},
    currentUser: null,
  }

  componentDidMount() {
    hasAccess(this.props.currentUser, 'ADMN: Partner Plan Notification', this.props.history, 'R', true)

    this.props.getPartnerplanReminderEmailToBeSent()
  }

  bannerProps = () => {
    const {
      routes, history, location, match, path,
    } = this.props
    return {
      name: 'Admin centre',
      history,
      location,
      path,
      match,
      routes,
    }
  }

  reminderNotification() {
    const locationPath = this.props.location.pathname
    const { routes } = this.props
    const currentRouteData = (routes.find(i => i.path === locationPath) || {}).data

    return currentRouteData.notification
  }

  render() {
    const {
      routes, currentUser,
    } = this.props

    return (
      <MainLayout bannerNavProps={{ ...this.bannerProps() }} showSidebar={false} sidebarType="partnerSideBar">
        <BackToAdminCentre displayText={`Send ${this.reminderNotification()} reminder email`} isAdmin={this.props.currentUser.IsAdmin} />
        <Container>
          {routes.map((route, i) => (
            <RouteWithSubRoutes
              key={i}
              {...route}
              currentUser={currentUser}
              getPartnerplanReminderEmailToBeSent={this.props.getPartnerplanReminderEmailToBeSent}
              partnerPlanReminderNotification={this.props.partnerPlanReminderNotification}
              reminderNotification={this.reminderNotification()}
              sendPartnerplanReminderEmail={this.props.sendPartnerplanReminderEmail}
              setErrorMessage={this.props.setErrorMessage}
            />
            ))}
        </Container>
      </MainLayout>
    )
  }
}

const mapStateToProps = state => ({
  errorMessage: state.errorMessage,
  partnerPlanReminderNotification: state.partnerPlanReminderNotification,
})

export default withRouter(connect(mapStateToProps, {
  resetErrorMessage,
  setErrorMessage,
  getPartnerplanReminderEmailToBeSent,
  sendPartnerplanReminderEmail,
})(partnerPlanReminderNotification))



// WEBPACK FOOTER //
// ./src/containers/PartnerPlanReminderNotification.js